import React from 'react';
import { Link } from 'react-router-dom';
import { type Step, getNextStep, getPreviousStep } from '../config/steps';

interface StepNavigationProps {
  currentStep: Step;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStep,
}) => {
  const previousStep = getPreviousStep(currentStep.id);
  const nextStep = getNextStep(currentStep.id);

  return (
    <div className='divider step-nav'>
      <div>
        {previousStep ? (
          <Link to={previousStep.path} className='btn btn-secondary focus-ring'>
            ← {previousStep.title}
          </Link>
        ) : (
          <div></div>
        )}
      </div>

      <div>
        {nextStep ? (
          <Link to={nextStep.path} className='btn btn-secondary focus-ring'>
            {nextStep.title} →
          </Link>
        ) : (
          <Link to='/' className='btn btn-secondary focus-ring'>
            ✓ Iz početka
          </Link>
        )}
      </div>
    </div>
  );
};
